import {useInfiniteQuery} from '@tanstack/react-query';
import {fetchUserFriends} from '../endpoints/api';
import useAuth from './useAuth';

export interface Connection {
  id: number;
  name: string;
  surname?: string;
  handle?: string;
  email?: string;
  profile_photo_url?: string;
  is_following?: boolean;
  is_followed_by?: boolean;
  is_friend?: boolean;
}

export const useConnections = (params?: {search?: string; type?: string}) => {
  const {user} = useAuth();
  const userId = user?.id;

  const query = useInfiniteQuery(
    ['connections', userId, params?.search, params?.type],
    async ({pageParam = 1}) => {
      if (!userId) return {data: [], current_page: 1, last_page: 1};
      const res = await fetchUserFriends(userId, {...params, page: pageParam});
      const payload = (res as any)?.data;
      // Guard against unexpected response shapes so getNextPageParam can't throw
      if (!payload || typeof payload !== 'object') {
        return {data: [], current_page: 1, last_page: 1};
      }
      return {
        data: Array.isArray(payload.data) ? payload.data : [],
        current_page: typeof payload.current_page === 'number' ? payload.current_page : 1,
        last_page: typeof payload.last_page === 'number' ? payload.last_page : 1,
      };
    },
    {
      enabled: !!userId,
      getNextPageParam: (lastPage: any) => {
        const current = lastPage?.current_page;
        const last = lastPage?.last_page;
        if (typeof current === 'number' && typeof last === 'number' && current < last) {
          return current + 1;
        }
        return undefined;
      },
    },
  );

  const connections: Connection[] = query.data?.pages.flatMap((page: any) =>
    page.data || [],
  ) || [];

  return {...query, connections};
};
